import {Injectable} from '@angular/core';
import {DatagridComponent} from "../../ui/datagrid/datagrid.component";

@Injectable()
export class DatatableService {
    constructor() {}

    deleteSelected(grid: DatagridComponent) {
        var checkboxColumn = grid.dtOptions.columns.find((o) => {
            return o.type === 'checkbox';
        });
        var dataKey = checkboxColumn.data;
        var data = grid.dtOptions.data.filter(function (o) {
            return o[dataKey] !== true;
        });
        var deletedItems = grid.dtOptions.data.filter(function (o) {
            return o[dataKey] === true;
        });
        this.replaceData(grid, data);
        return deletedItems;
    }

    replaceData(grid: DatagridComponent, data) {
        grid.replaceData(data);
    }

}
